import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import { buildInteractiveResult } from "./utils";
import { sanitizeUrl } from "@braintree/sanitize-url";
import { SourceLabel } from "./SourceLabel";

// https://docs.coveo.com/en/headless/latest/reference/search/controllers/interactive-result/
// An interactive results handles the analytics of users selecting a result
export const InteractiveResult = (props) => {
  const { headlessEngine, result } = props;
  const controller = buildInteractiveResult(headlessEngine, {
    options: { result: props.result }
  });
  useEffect(() => () => controller.cancelPendingSelect());

  const isKbArticleUrl = (uri) => uri.includes("/help/s/article/");

  const removeOrigin = (uri) => {
    const url = new URL(uri);
    return `${url.pathname}${url.search}${url.hash}`;
  };

  const addLocalOrigin = (relativeUri) => `${window.location.origin}${relativeUri}`;

  const targetUrl = sanitizeUrl(result.clickUri);

  // KB articles are displayed within Support Center, so we'll convert the link to a "to" react router destination
  const internalUrl = isKbArticleUrl(targetUrl) ? removeOrigin(targetUrl) : undefined;
  const printableUri = internalUrl
    // in case there's a mismatch between the result's origin and the origin where the app is running
    // we'll use the app's origin for display purposes
    ? addLocalOrigin(internalUrl)
    : result.printableUri;

  return (
    <Link
      to={internalUrl}
      href={internalUrl ? undefined : targetUrl}
      onClick={controller.select}
      onContextMenu={controller.select}
      onMouseDown={controller.select}
      onMouseUp={controller.select}
      onTouchStart={controller.beginDelayedSelect}
      onTouchEnd={controller.cancelPendingSelect}
    >
      <cite>
        <SourceLabel result={result} />
        <span className="url">{printableUri}</span>
      </cite>
      <h3>{result.title}</h3>
    </Link>
  );
};

InteractiveResult.propTypes = {
  headlessEngine: PropTypes.object,
  result: PropTypes.object
};
